import { render, staticRenderFns } from "./ekyc-bind-dialog.vue?vue&type=template&id=92f4ea88&scoped=true"
import script from "./ekyc-bind-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ekyc-bind-dialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ekyc-bind-dialog.vue?vue&type=style&index=0&id=92f4ea88&prod&lang=less"
import style1 from "./ekyc-bind-dialog.vue?vue&type=style&index=1&id=92f4ea88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f4ea88",
  null
  
)

export default component.exports